import { Pause as PauseIcon, PlayArrow as PlayIcon } from '@mui/icons-material';
import { IconButton, IconButtonProps } from '@mui/material';

export interface PlaybackBtnProps extends Omit<IconButtonProps, 'children' | 'color'> {
  readonly isPlaying: boolean;
}

export const PlaybackBtn = ({ isPlaying, ...props }: PlaybackBtnProps) => {
  return (
    <IconButton
      color={isPlaying ? 'primary' : 'default'}
      sx={{
        paddingLeft: isPlaying ? 0 : '0.1rem',
      }}
      {...props}
    >
      {isPlaying ? <PauseIcon /> : <PlayIcon />}
    </IconButton>
  );
};
